var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view_FinishPaper"},[_c('CommonFinishPaper',{ref:"commonFinishPaper",attrs:{"autoid":_vm.mautoid,"username":_vm.username}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }